function initSlyders(){

    window.slyder = Array();

    window.slyder['about'] = new Swiper('.slyder-about', {

        direction: 'horizontal',
        loop: false,
        spaceBetween: 24,

        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="about"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="about"]',
        },

        breakpoints: {
        
            768: {

                width: 462,
            
            },
            1280: {

                width: 494,
            
            }
        
        },
    });

    window.slyder['products'] = new Swiper('.slyder-products', {

        direction: 'horizontal',
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,

        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="products"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="products"]',
        },

        breakpoints: {

            768: {

                slidesPerView: 2,
            
            },
        
            1280: {

                slidesPerView: 3,
            
            }
        
        },
    });

    window.slyder['service'] = new Swiper('.slyder-service', {

        direction: 'horizontal',
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,

        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="service"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="service"]',
        },

        breakpoints: {
        
            768: {

                slidesPerView: 2,
            
            },
        
            1280: {

                slidesPerView: 3,
            
            }
        
        },
    });

    window.slyder['portfolio'] = new Swiper('.slyder-portfolio', {

        direction: 'horizontal',
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,

        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="portfolio"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="portfolio"]',
        },

        breakpoints: {
        
            768: {

                slidesPerView: 2,
            
            },
        
            1280: {

                slidesPerView: 3,
            
            }
        
        },
    });

    window.slyder['brands'] = new Swiper('.slyder-brands', {

        direction: 'horizontal',
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,

        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="brands"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="brands"]',
        },

        breakpoints: {
        
            768: {

                slidesPerView: 6,
            
            }
        
        },

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            //dynamicBullets: true,
        },
    });

    window.slyder['product-thumbs'] = new Swiper('.slyder-product-thumbs', {

        spaceBetween: 8,
    	slidesPerView: 6,
    	freeMode: true,
    	watchSlidesProgress: true,
    });

    window.slyder['product-gallery'] = new Swiper('.slyder-product-gallery', {

        spaceBetween: 10,

        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="product-gallery"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="product-gallery"]',
        },
        thumbs:{

            swiper: window.slyder['product-thumbs']

        },
    });

    window.slyder['product-gallery'] = new Swiper('.gallery-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
            nextEl: '[data-event="ui.slyder.next"][data-slyder-name="product-gallery"]',
            prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="product-gallery"]',
        }
    });






    document.querySelectorAll('.slyder-gallery').forEach((item) => {

        let id = item.getAttribute('slyder-id');

            window.slyder['gallery-'+id] = new Swiper(item, {
            
            direction: 'horizontal',
            loop: false,
            spaceBetween: 24,
            slidesPerView: 1,
            
            navigation: {
                nextEl: '[data-event="ui.slyder.next"][data-slyder-name="gallery-'+id+'"]',
                prevEl: '[data-event="ui.slyder.prev"][data-slyder-name="gallery-'+id+'"]',
            },
        

        });

    });

}

function initPopup(name){

    const dialog = document.querySelector(`#popup-${name}`);

    if(!dialog){return;}
    
    dialog.addEventListener('close', () => {

        enableScroll();
    });

    const closeButton = document.querySelector(`#popup-${name} .close`);
    const showButton = document.querySelectorAll(`[data-popup="popup-${name}"]`);

    if(showButton){

        showButton.forEach((item) => {

            item.addEventListener("click", () => {
                disableScroll();
                dialog.showModal();
            });

        });

    }

    if(!closeButton){

        return;

    }

    closeButton.addEventListener("click", () => {

        dialog.close();
        
    });

}

function headerScroll(e){

    const header = document.querySelector('header');

    if (window.scrollY > 50) {

        header.classList.add('scroll');

    } else {

        header.classList.remove('scroll');

    }

}

function headerMode(name){

    document.querySelector('header').classList.add(`mode-${name}`);

}

function openHeaderSubMenu() {
  document.querySelector('header').classList.add('sub-menu-mode');
  const scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  // disableScroll();
}

function closeHeaderSubMenu() {
  document.querySelector('header').classList.remove('sub-menu-mode');
  enableScroll();
  const scrollY = document.body.style.top;
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

function initHeaderSubMenu() {
    const showButtons = document.querySelectorAll('[data-event="toggler-submenu"]');
    const headerItems = document.querySelectorAll(
    'header .lvl-1, .logo, header .actions, .navigation .nav-item:not(:first-child)'
    );

  if (!showButtons.length || !headerItems.length) return;

  // навешиваем слушатели на кнопки
  function attachShowButtons() {
    showButtons.forEach(item => {
      item.addEventListener('mouseenter', onShowButton, { once: true });
    });
  }

  // навешиваем слушатели на элементы для закрытия
  function attachHeaderItems() {
    headerItems.forEach(item => {
      item.addEventListener('mouseenter', onHeaderItem, { once: true });
    });
  }

  // обработчик открытия
  function onShowButton(e) {
    openHeaderSubMenu(); // вызываем функцию открытия
    // после открытия ждём закрывающие элементы
    attachHeaderItems();
  }

  // обработчик закрытия
  function onHeaderItem(e) {
    closeHeaderSubMenu(); // вызываем функцию закрытия
    // после закрытия снова разрешаем открытие
    attachShowButtons();
  }

  // стартовое навешивание
  attachShowButtons();
}






function disableScroll() {

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  
    window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
    };

}

function enableScroll() {

    window.onscroll = null;

}

function setTab(name,tab){

    hideTabs(name);

    document.querySelectorAll(`[data-tabs="${name}"][data-tab="${tab}"]`).forEach((item) => {

        item.classList.add('active');

    });

    document.querySelectorAll(`[data-tabs-name="${name}"][data-tab="${tab}"]`).forEach((item) => {

        item.classList.remove('d-hide');

    });

}

function hideTabs(name){

    document.querySelectorAll(`[data-tabs="${name}"]`).forEach((item) => {

        item.classList.remove('active');

    });

    document.querySelectorAll(`[data-tabs-name="${name}"]`).forEach((item) => {

        item.classList.add('d-hide');

    });

}

function initTabs(){

    const arr = [];


    document.querySelectorAll('[data-tabs]').forEach((item) => {

        let name = item.getAttribute('data-tabs');

        if(arr.indexOf(name) < 0){

            arr.push(name);

        }

    });

    document.querySelectorAll('[data-event="tabs.toggle"]').forEach((item) => {

        item.addEventListener('click', (e) => {

            let tab = e.target.getAttribute('data-tabs');
            let name = e.target.getAttribute('data-tab');

            setTab(tab,name);

        });

    });


    for(let item of arr){

        hideTabs(item);

    }

    for(let item of arr){

        let el = document.querySelectorAll(`[data-tabs-name="${item}"][data-tab]`);

        if(el.length > 0){

            let name = el[0].getAttribute('data-tab');

            setTab(item,name);

        }


    }

}

function initQty(){

    const quantityControls = document.querySelectorAll('.input-qty');

    quantityControls.forEach(control => {

        const minusBtn = control.querySelector('button:first-child');
        const plusBtn = control.querySelector('button:last-child');
        const input = control.querySelector('input[type="number"]');
        
        minusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            let value = parseInt(input.value) || 0;
            if (value > 1) {
                input.value = value - 1;
                triggerInputEvent(input);
            }
        });
        
        plusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            let value = parseInt(input.value) || 0;
            input.value = value + 1;
            triggerInputEvent(input);
        });
        
        input.addEventListener('input', function() {
            let value = parseInt(this.value) || 1;
            if (value < 1) value = 1;
            this.value = value;
        });

    });

    function triggerInputEvent(element) {
        const event = new Event('input', {
            bubbles: true,
            cancelable: true,
        });
        element.dispatchEvent(event);
    }

}

function setInputFiles(name) {
    
    const fileAddButton = document.querySelector(`button[data-event="file.add"][data-name="${name}"]`);
    const fileInput = document.getElementById(`${name}-input`);
    const fileList = document.getElementById(`${name}-list`);
        
    let filesStore = [];
    let formData = new FormData();

    fileAddButton.addEventListener('click', () => {
        fileInput.value = ''; 
        fileInput.click();
    });
    
    fileInput.addEventListener('change', function() {

        if (!this.files.length){return;}
        
        Array.from(this.files).forEach(file => {
            filesStore.push(file);
        });
        
        
        updateFilesList();
        updateFormData();
    });
    
    function updateFilesList() {
        
        fileList.innerHTML = '';
        
        
        filesStore.forEach((file, index) => {
            
            const fileItem = document.createElement('div');
            fileItem.className = 'item';
            fileItem.setAttribute('data-event', 'file.remove');
            fileItem.setAttribute('data-name', name);
            fileItem.setAttribute('data-index', index);
            
            
            const fileLink = document.createElement('a');
            fileLink.href = '#';
            fileLink.className = 'filename';
            fileLink.textContent = file.name;
            
            
            const deleteIcon = document.createElement('img');
            deleteIcon.src = 'catalog/view/theme/default/dist/images/icons/cross-red.svg';
            deleteIcon.alt = 'icon cross';
            
            fileItem.appendChild(fileLink);
            fileItem.appendChild(deleteIcon);
            fileList.appendChild(fileItem);
        });
    
        updateRemoveHandlers();
    }

    function updateFormData() {

        formData = new FormData();

        filesStore.forEach((file, index) => {
            formData.append(`${name}-${index}`, file);
        });

    }

    function updateRemoveHandlers() {

        fileList.querySelectorAll('[data-event="file.remove"]').forEach(item => {
            item.addEventListener('click', function(e) {

                e.preventDefault();
                const index = parseInt(this.getAttribute('data-index'));
                
                // Удаляем файл из хранилища
                filesStore.splice(index, 1);
                
                // Обновляем список файлов в DOM
                updateFilesList();
                
                // Обновляем FormData
                updateFormData();
                
                const dataTransfer = new DataTransfer();
                
                filesStore.forEach(file => {
                    dataTransfer.items.add(file);
                });
                
                fileInput.files = dataTransfer.files;
            });

        });

    }
}

function initInputFiles(){

    let arr = [];

    document.querySelectorAll('[data-setfiles-name]').forEach((item) => {

        let name = item.getAttribute('data-setfiles-name');

        if(!arr.indexOf(name) >= 0){

            arr.push(name);

        }

    });


    for(let name of arr){

        setInputFiles(name);

        

    }
}

function initMaskPhone(){

    const inputPhone = document.querySelectorAll('[data-event="phone.mask"]');

    const prefixNumber = (digit) => {
        if (digit === "7") return "7 (";
        if (digit === "8") return "8 (";
        if (digit === "9") return "7 (9";
        return "7 (";
    };


    inputPhone.forEach((el) => {
        el.addEventListener("input", () => {
            let value = el.value.replace(/\D+/g, "").slice(0, 11);
            let result = el.value.startsWith("+8") || el.value.startsWith("8") ? "" : "+";

            result += value[0] ? prefixNumber(value[0]) : "";

            const formatMap = { 4: ") ", 7: "-", 9: "-" };

            value.split("").forEach((char, index) => {
                if (formatMap[index]) result += formatMap[index];
                if (index > 0) result += char;
            });

            el.value = result;
        });
    });

}

// Считаем кол-во слайдов

function indexItemsNumbers() {
  const slyders = document.querySelectorAll('.slyder');

  slyders.forEach(slyder => {
    const slides = slyder.querySelectorAll('.swiper-slide');

    slides.forEach((slide, index) => {
      const numberEl = slide.querySelector('.number');
      if (numberEl) {
        numberEl.textContent = index + 1;
      }
    });
  });
}


// Склоняем слово товар

function getGoodsDeclension(count) {
    const num = Math.abs(count) % 100;
    const lastDigit = num % 10;
    
    if (num > 10 && num < 20) {
        return 'товаров';
    }
    
    if (lastDigit === 1) {
        return 'товар';
    }
    
    if (lastDigit >= 2 && lastDigit <= 4) {
        return 'товара';
    }
    
    return 'товаров';
}


function updateGoodsCount() {
    const cards = document.querySelectorAll('.card-catalog');
    
    cards.forEach(card => {
        const countElement = card.querySelector('.s14x20 span');
        const countText = card.querySelector('.s14x20').textContent.split(' ')[0];
        
        if (countElement && countText) {
            const count = parseInt(countText, 10);
            countElement.textContent = getGoodsDeclension(count);
        }
    });
}

// Подгрузка новых карточек в категории при клике на кнопку

function initLoadMore() {
    const btn = document.getElementById('load-more');
    const list = document.getElementById('product-list');
    if (!btn || !list) return;

    let page = parseInt(btn.dataset.page || 1, 10);
    const totalPages = parseInt(btn.dataset.totalPages || 1, 10);

    btn.addEventListener('click', () => {
        page++;
        if (page > totalPages) {
            btn.remove();
            return;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('page', page);

        fetch(url)
            .then(res => res.text())
            .then(html => {
                const temp = document.createElement('div');
                temp.innerHTML = html;

                // достаём только карточки товаров из следующей страницы
                const newProducts = temp.querySelectorAll('#product-list .card-product');
                if (newProducts.length) {
                    newProducts.forEach(card => list.appendChild(card));
                    updateGoodsCount(); // обновляем счётчики
                    if (page >= totalPages) btn.remove();
                } else {
                    btn.remove();
                }
            })
            .catch(console.error);
    });
}

// Получаем ссылки на кнопки на странице все категории(allproducts)

function initSubCategoryButtons() {
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.tags .item[data-href]');
        if (btn) {
            e.preventDefault();      
            e.stopPropagation();    
            window.location.href = btn.dataset.href;
        }
    });
}

function liveSearch() {
    const input = document.querySelector('#popup-search input[name="search"]');
    const list = document.querySelector('#popup-search .search-list');
    const btn  = document.querySelector('#popup-search .btn-primary');

    let timer;

    input.addEventListener('input', () => {
        clearTimeout(timer);
        const term = input.value.trim();

        if (term.length < 1) {
            list.innerHTML = '';
            btn.textContent = 'Показать результаты';
            return;
        }

        timer = setTimeout(() => {
            fetch(`index.php?route=common/livesearch&term=${encodeURIComponent(term)}`)
                .then(res => res.json())
                .then(data => {
                    list.innerHTML = '';

                    if (data.categories) {
                        data.categories.slice(0, 5).forEach(cat => {
                            list.insertAdjacentHTML('beforeend', `
                                <a href="${cat.href}" class="item category-item">
                                    <span class="category-item-icon">
                                    <img src="catalog/view/theme/default/dist/images/icons/search-gray.svg" alt="">
                                    </span>
                                    <span>${cat.name}</span>
                                </a>
                            `);
                        });
                    }

                    if (data.products) {
                        data.products.slice(0, 8).forEach(prod => {
                            list.insertAdjacentHTML('beforeend', `
                                <a href="${prod.href}" class="item item-product">
                                    <img src="${prod.image}" alt="">
                                    <span>${prod.name}</span>
                                </a>
                            `);
                        });
                    }


                    btn.textContent = `Показать результаты (${data.total_products || 0})`;
                    btn.onclick = () => {
                        window.location.href = `index.php?route=product/search&search=${encodeURIComponent(term)}`;
                    };
                });
        }, 300); 
    });
}

// Корзина

function cart() {
    const notifCountEls = document.querySelectorAll('.notif-count'); // все счетчики
    const notifBox = document.querySelector('.cart-notification');
    const notifProductName = document.querySelector('.cart-notification__product');

    // Навешиваем обработчики на все кнопки "добавить в корзину"
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
        btn.addEventListener('click', () => {
            const productId = btn.getAttribute('data-add-to-cart'); 
            let productName = '';

            // Пытаемся взять название из карточки товара
            const card = btn.closest('.card-product');
            if (card) {
                const nameEl = card.querySelector('p.f-accent');
                if (nameEl) productName = nameEl.textContent.trim();
            }

            // Если карточки нет — пробуем h1
            if (!productName) {
                const h1 = document.querySelector('h1.title');
                if (h1) productName = h1.textContent.trim();
            }

            addToCart(productId, productName);
            ym(42169839, 'reachGoal', 'addToCart');
        });
    });

    function addToCart(productId, productName) {
        fetch('index.php?route=checkout/cart/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams({
                product_id: productId,
                quantity: 1
            })
        })
        .then(res => res.json())
        .then(json => {
            if (json.success) {
                // Обновляем все счетчики
                if (json.total_products !== undefined && notifCountEls.length) {
                    notifCountEls.forEach(el => {
                        el.textContent = json.total_products;
                        el.classList.add('active');
                    });
                }

                // Показываем уведомление
                if (notifBox && notifProductName) {
                    notifProductName.textContent = productName;
                    notifBox.classList.add('active');
                    setTimeout(() => notifBox.classList.remove('active'), 3000);
                }
            }

            // Если сервер вернул редирект
            if (json.redirect) {
                window.location.href = json.redirect;
            }
        })
        .catch(err => console.error('Ошибка добавления в корзину:', err));
    }
}


// Проверяем колличество товаров в корзине во время загрузки страницы

function updateCartCountOnLoad() {
    fetch('index.php?route=checkout/cart/count') 
        .then(res => res.json())
        .then(json => {
            if (json.total_products !== undefined) {
                const countEls = document.querySelectorAll('.notif-count');

                countEls.forEach(el => {
                    if (json.total_products > 0) {
                        el.textContent = json.total_products;
                        el.classList.add('active');
                    } else {
                        el.textContent = '';
                        el.classList.remove('active');
                    }
                });
            }
        })
        .catch(err => console.error('Ошибка загрузки количества товаров в корзине:', err));
}



// Кнопка убрать товары из корзины

function initCartClear() {
    const clearBtn = document.querySelector('[data-event="cart.clear"]');
    if (!clearBtn) return;

    clearBtn.addEventListener('click', () => {

        const ids = Array.from(document.querySelectorAll('[data-event="cart.remove"]'))
            .map(btn => btn.dataset.id);

        if (!ids.length) return;

        Promise.all(ids.map(id => {
            return fetch('index.php?route=checkout/cart/remove', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: new URLSearchParams({ key: id })
            });
        }))
        .then(() => location.reload());
    });
}



// Удаление в корзине

function initCartRemoveButtons() {
    document.querySelectorAll('[data-event="cart.remove"]').forEach(btn => {
        btn.addEventListener('click', () => {
            const cartId = btn.dataset.id;
            const itemEl = btn.closest('.item');

            fetch('index.php?route=checkout/cart/remove', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: new URLSearchParams({ key: cartId })
            })
            .then(() => {
                // Удаляем товар из DOM
                if (itemEl) {
                    itemEl.remove();
                }

                // Пересчитываем общий итог
                recalcCartTotal();

                // Запрашиваем новое количество товаров
                return fetch('index.php?route=checkout/cart/count');
            })
            .then(res => res.json())
            .then(json => {
                if (json && typeof json.total_products !== 'undefined') {
                    // Обновляем все счетчики
                    const notifEls = document.querySelectorAll('.notif-count');
                    notifEls.forEach(el => {
                        el.textContent = json.total_products;
                        if (json.total_products > 0) {
                            el.classList.add('active');
                        } else {
                            el.classList.remove('active');
                        }
                    });

                    // Обновляем текст "В корзине X товара"
                    const cartQtyText = document.querySelector('.s16x24.clr-600');
                    if (cartQtyText) {
                        cartQtyText.textContent = `В корзине ${json.total_products} товара`;
                    }
                }
            })
            .catch(err => console.error('Ошибка удаления из корзины:', err));
        });
    });
}


// Добавление в корзине

function initCartQtyButtons() {
    document.querySelectorAll('[data-event="qty.plus"], [data-event="qty.minus"]').forEach(btn => {
        btn.addEventListener('click', () => {
            const cartId = btn.dataset.id;
            const input = document.querySelector(`input[name="qty-${cartId}"]`);
            let qty = parseInt(input.value) || 1;

            if (btn.dataset.event === 'qty.plus') {
                qty++;
            } else if (btn.dataset.event === 'qty.minus' && qty > 1) {
                qty--;
            }

            input.value = qty;

            // Пересчёт суммы за позицию
            const pricePerUnitEl = input.closest('.item').querySelector('.clr-400.s12x20');
            const totalEl = document.querySelector(`[data-total-id="${cartId}"]`);

            if (pricePerUnitEl && totalEl) {
                const priceText = pricePerUnitEl.textContent.trim();
                if (!priceText.includes('Договорная')) {
                    const priceNum = parseFloat(priceText.replace(/[^\d.,]/g, '').replace(',', '.'));
                    if (!isNaN(priceNum)) {
                        const newTotal = (priceNum * qty).toLocaleString('ru-RU');
                        totalEl.textContent = `${newTotal} ₽`;
                    }
                }
            }

            recalcCartTotal();

            // Обновляем на сервере
            fetch('index.php?route=checkout/cart/edit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body: new URLSearchParams({ [`quantity[${cartId}]`]: qty })
            })
            .then(() => {
                // Запрашиваем новое количество товаров
                return fetch('index.php?route=checkout/cart/count');
            })
            .then(res => res.json())
            .then(json => {
                if (json && typeof json.total_products !== 'undefined') {
                    // Обновляем все счетчики
                    const notifEls = document.querySelectorAll('.notif-count');
                    notifEls.forEach(el => {
                        el.textContent = json.total_products;
                        if (json.total_products > 0) {
                            el.classList.add('active');
                        } else {
                            el.classList.remove('active');
                        }
                    });

                    // Обновляем текст "В корзине X товара"
                    const cartQtyText = document.querySelector('.s16x24.clr-600');
                    if (cartQtyText) {
                        cartQtyText.textContent = `В корзине ${json.total_products} товара`;
                    }
                }
            })
            .catch(err => console.error('Ошибка обновления корзины:', err));
        });
    });
}


function recalcCartTotal() {
    let grandTotal = 0;
    let hasZeroPrice = false;

    document.querySelectorAll('.item').forEach(item => {
        const pricePerUnitEl = item.querySelector('.clr-400.s12x20');
        const qtyInput = item.querySelector('input[type="number"]');

        if (!pricePerUnitEl || !qtyInput) return;

        const priceText = pricePerUnitEl.textContent.trim();

        // Если цена "Договорная" — сразу помечаем флаг
        if (priceText.includes('Договорная')) {
            hasZeroPrice = true;
            return;
        }

        const priceNum = parseFloat(priceText.replace(/[^\d.,]/g, '').replace(',', '.'));
        const qty = parseInt(qtyInput.value) || 0;

        if (!isNaN(priceNum) && qty > 0) {
            if (priceNum === 0) {
                hasZeroPrice = true;
            }
            grandTotal += priceNum * qty;
        }
    });

    // Обновляем блок общего итога
    const totalBox = document.querySelector('#cart-grand-total');
    if (totalBox) {
        if (hasZeroPrice) {
            totalBox.innerHTML = `Договорная`;
        } else {
            totalBox.innerHTML = `${grandTotal.toLocaleString('ru-RU')} <span class="s18x24">₽</span>`;
        }
    }
}

// Теги

function initTagFilter() {
    const tagButtons = document.querySelectorAll('.tags .item');
    const cards = document.querySelectorAll('.card-service, .card-project');

    if (!tagButtons.length || !cards.length) return;

    let activeTag = null;

    tagButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const selectedTag = btn.getAttribute('data-tag');

            if (activeTag === selectedTag) {
                activeTag = null;
                tagButtons.forEach(b => b.classList.remove('active'));
                cards.forEach(card => card.style.display = '');
                return;
            }

            activeTag = selectedTag;

            tagButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            cards.forEach(card => {
                const tags = card.getAttribute('data-tag')
                    .split(',')
                    .map(t => t.trim());

                if (!selectedTag || tags.includes(selectedTag)) {
                    card.style.display = '';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    });
}

// Сворачиваемое меню в подвале

function initFooterColToggle() {
  const cols = document.querySelectorAll('footer .lvl-1 .col');

  cols.forEach(col => {
    const links = Array.from(col.querySelectorAll('a'));
    if (links.length <= 8) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('footer_collapsed_menus', 'collapsed-footer-col');

    links.forEach(link => wrapper.appendChild(link));
    col.appendChild(wrapper);

    const toggleBtn = document.createElement('button');
    toggleBtn.classList.add('footer-toggle-btn');
    toggleBtn.textContent = 'Показать ещё';

    col.appendChild(toggleBtn);

    toggleBtn.addEventListener('click', () => {
      const isExpanded = wrapper.classList.contains('expanded-footer-col');

      if (isExpanded) {
        wrapper.classList.remove('expanded-footer-col');
        wrapper.classList.add('collapsed-footer-col');
        toggleBtn.textContent = 'Показать ещё';
      } else {
        wrapper.classList.remove('collapsed-footer-col');
        wrapper.classList.add('expanded-footer-col');
        toggleBtn.textContent = 'Скрыть';
      }
    });
  });
}

// Мобильный каталог

function initPopupCatalogToggle() {
  const cols = document.querySelectorAll('.popup-catalog .col');

  cols.forEach(col => {
    const title = col.querySelector('.group-title');
    const links = Array.from(col.querySelectorAll('.group-link'));

    if (!title || links.length === 0) return;

    const submenu = document.createElement('div');
    submenu.classList.add('submenu');
    submenu.style.display = 'none';
    submenu.style.overflow = 'hidden';
    submenu.style.opacity = '0';
    submenu.style.height = '0';

    links.forEach(link => submenu.appendChild(link));
    col.appendChild(submenu);

    title.addEventListener('click', e => {
      e.preventDefault();
      const isExpanded = title.classList.contains('active');

      if (isExpanded) {

        const startHeight = submenu.scrollHeight;
        submenu.style.height = startHeight + 'px';
        submenu.style.opacity = '1';
        requestAnimationFrame(() => {
          submenu.style.transition = 'height 0.3s ease, opacity 0.3s ease';
          submenu.style.height = '0';
          submenu.style.opacity = '0';
        });
        submenu.addEventListener('transitionend', function handler() {
          submenu.style.display = 'none';
          submenu.style.transition = '';
          title.classList.remove('active');
          submenu.removeEventListener('transitionend', handler);
        });
      } else {

        submenu.style.display = 'block';
        const targetHeight = submenu.scrollHeight;
        submenu.style.height = '0';
        submenu.style.opacity = '0';
        requestAnimationFrame(() => {
          submenu.style.transition = 'height 0.3s ease, opacity 0.3s ease';
          submenu.style.height = targetHeight + 'px';
          submenu.style.opacity = '1';
        });
        submenu.addEventListener('transitionend', function handler() {
          submenu.style.height = 'auto';
          submenu.style.transition = '';
          title.classList.add('active');
          submenu.removeEventListener('transitionend', handler);
        });
      }
    });
  });
}


window.points = [
    { latitude: 56.8389, longitude: 60.6057, title: "Екатеринбург" },
    { latitude: 55.018803, longitude: 82.933952, title: "Новосибирск" },
    { latitude: 46.959155, longitude: 142.738013, title: "Южно-Сахалинск" },
    { latitude: 43.115536, longitude: 131.885485, title: "Владивосток" },
    { latitude: 56.015283, longitude: 92.893248, title: "Красноярск" },
    { latitude: 55.755814, longitude: 37.617635, title: "Москва" },
    { latitude: 45.035470, longitude: 38.975313, title: "Краснодар" },
    { latitude: 52.289588, longitude: 104.280606, title: "Иркутск" },
    { latitude: 56.326887, longitude: 44.005986, title: "Нижний Новгород" }
];

async function initMap() {
    const mapContainer = document.getElementById('objects-map');

    if (
        !mapContainer ||
        !Array.isArray(window.points) ||
        !window.points.length
    ) {
        return;
    }

    const response = await fetch(
        'catalog/view/theme/default/dist/map/customization.json'
    );

    const mapCustomization = await response.json();

    await ymaps3.ready;

    const {
        YMap,
        YMapDefaultSchemeLayer,
        YMapDefaultFeaturesLayer,
        YMapMarker
    } = ymaps3;

    const zoom = parseInt(mapContainer.dataset.zoom, 10) || 4;

    const coordinates = window.points
        .map(point => [
            Number(point.longitude),
            Number(point.latitude)
        ])
        .filter(([longitude, latitude]) => {
            return (
                Number.isFinite(longitude) &&
                Number.isFinite(latitude)
            );
        });

    if (!coordinates.length) {
        return;
    }

    const longitudes = coordinates.map(([longitude]) => longitude);
    const latitudes = coordinates.map(([, latitude]) => latitude);

    const bounds = [
        [
            Math.min(...longitudes),
            Math.min(...latitudes)
        ],
        [
            Math.max(...longitudes),
            Math.max(...latitudes)
        ]
    ];

    const map = new YMap(
        mapContainer,
        {
            location: {
                center: coordinates[0],
                zoom: zoom
            },
            margin: [40, 40, 40, 40],
            behaviors: [
                'drag',
                'dblClick',
                'pinchZoom',
                'mouseRotate',
                'mouseTilt'
            ]
        },
        [
            new YMapDefaultSchemeLayer({
                theme: 'dark',
                customization: mapCustomization
            }),
            new YMapDefaultFeaturesLayer({})
        ]
    );

    window.points.forEach(point => {
        const longitude = Number(point.longitude);
        const latitude = Number(point.latitude);

        if (
            !Number.isFinite(longitude) ||
            !Number.isFinite(latitude)
        ) {
            return;
        }

        const markerElement = document.createElement('div');

        markerElement.className = 'objects-map-marker';
        markerElement.title = point.title || '';

        const markerImage = document.createElement('img');

        markerImage.src =
            'catalog/view/theme/default/dist/images/icons/map_icon.png';

        markerImage.alt = point.title || '';
        markerImage.draggable = false;

        markerElement.appendChild(markerImage);

        map.addChild(
            new YMapMarker(
                {
                    coordinates: [longitude, latitude]
                },
                markerElement
            )
        );
    });

    map.update({
        location: {
            bounds: bounds,
            easing: 'ease-in-out',
            duration: 0
        }
    });

    window.objectsMap = map;
}

function informationLinkContents() {
  const tocContainer = document.querySelector('.info-content-links');
  const contentArea = document.querySelector('.col-2');
  const tocTitle = document.querySelector('.sidebar-links p.clr-500');
  const calcButton = document.querySelector('.col-1 .btn[data-popup="popup-bid"]');

  if (!tocContainer || !contentArea || !calcButton || !tocTitle) return;

  const headings = contentArea.querySelectorAll('h2, h3, h4');
  const baseUrl = window.location.origin + window.location.pathname; 

  if (headings.length === 0) {
    // Нет заголовков → скрываем оглавление, показываем кнопку
    tocTitle.style.display = 'none';
    tocContainer.style.display = 'none';
    calcButton.style.display = 'flex';
    return;
  }

  // Есть заголовки → показываем оглавление, скрываем кнопку
  tocTitle.style.display = '';
  tocContainer.style.display = '';
  calcButton.style.display = 'none';

  tocContainer.innerHTML = '';

  headings.forEach((heading, index) => {
    const anchorId = 'section-' + (index + 1);
    heading.id = anchorId;

    const link = document.createElement('a');
    link.href = baseUrl + '#' + anchorId;
    link.textContent = heading.textContent.trim();

    if (heading.tagName === 'H3') {
      link.classList.add('toc-sub');
    } else if (heading.tagName === 'H4') {
      link.classList.add('toc-sub-sub');
    }

    tocContainer.appendChild(link);
  });
}

// Проверка токена Yandex SmartCaptcha

function getSmartCaptchaToken(form) {
    const tokenInput = form.querySelector('input[name="smart-token"]');

    if (!tokenInput) {
        return '';
    }

    return tokenInput.value.trim();
}


// Проверка SmartCaptcha перед отправкой

function validateSmartCaptcha(form) {
    const captchaContainer = form.querySelector('.smart-captcha');

    // Если в форме нет капчи — пропускаем проверку.
    // Это позволяет использовать код на страницах, где капча ещё не добавлена.
    if (!captchaContainer) {
        return true;
    }

    const token = getSmartCaptchaToken(form);

    if (!token) {
        alert('Подтвердите, что вы не робот');
        return false;
    }

    return true;
}


// Блокировка кнопки во время отправки

function setFormSubmitting(form, isSubmitting) {
    const submitButton = form.querySelector('button[type="submit"]');

    if (!submitButton) {
        return;
    }

    if (isSubmitting) {
        submitButton.dataset.originalText = submitButton.textContent;
        submitButton.textContent = 'Отправка...';
        submitButton.disabled = true;
    } else {
        submitButton.textContent =
            submitButton.dataset.originalText || 'Отправить';

        submitButton.disabled = false;
    }
}


// Безопасная отправка цели в Яндекс Метрику

function sendMetricaGoal(goalName) {
    if (typeof window.ym === 'function') {
        window.ym(42169839, 'reachGoal', goalName);
    }
}


// Отправка данных для форм обратной связи

function initCallbackForm() {
    const forms = document.querySelectorAll(
        '.form-callback form, .form-popup form'
    );

    if (!forms.length) {
        return;
    }

    // Обработчик клика по кнопке открытия popup-bid
    // на странице товара
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-popup="popup-bid"]');

        if (!btn) {
            return;
        }

        const productName =
            btn.getAttribute('data-product-name') || '';

        const popup = document.getElementById('popup-bid');

        if (!popup) {
            return;
        }

        const hiddenInput = popup.querySelector(
            '#popup-bid-product-name'
        );

        const titleEl = popup.querySelector('.form-popup h2');

        if (hiddenInput) {
            hiddenInput.value = productName;
        }

        if (titleEl) {
            titleEl.textContent = productName
                ? 'Оставить заявку на: ' + productName
                : 'Оставьте заявку';
        }
    });

    forms.forEach(function (formItem) {
        formItem.addEventListener('submit', function (e) {
            e.preventDefault();

            // Проверка стандартных required-полей
            if (!formItem.checkValidity()) {
                formItem.reportValidity();
                return;
            }

            // Проверка SmartCaptcha
            if (!validateSmartCaptcha(formItem)) {
                return;
            }

            setFormSubmitting(formItem, true);

            const formData = new FormData(formItem);

            // smart-token уже будет внутри formData автоматически,
            // потому что SmartCaptcha добавляет hidden input в форму.

            fetch(
                'index.php?route=extension/module/callback/send',
                {
                    method: 'POST',
                    body: formData
                }
            )
                .then(function (response) {
                    return response.text().then(function (text) {
                        return {
                            ok: response.ok,
                            text: text
                        };
                    });
                })
                .then(function (responseData) {
                    let data;

                    try {
                        data = JSON.parse(responseData.text);
                    } catch (error) {
                        console.error(
                            'Ответ сервера не является JSON:',
                            responseData.text
                        );

                        throw new Error(
                            'Некорректный ответ сервера'
                        );
                    }

                    if (!responseData.ok) {
                        throw new Error(
                            data.message || 'Ошибка сервера'
                        );
                    }

                    console.log('Callback response:', data);

                    if (data.status !== 'success') {
                        alert(
                            data.message || 'Ошибка отправки'
                        );

                        return;
                    }

                    const isStaticForm = Boolean(
                        formItem.closest('.form-callback')
                    );

                    const isPopupForm = Boolean(
                        formItem.closest('.form-popup')
                    );

                    // Сброс формы
                    formItem.reset();

                    // Очистка файлов
                    formItem
                        .querySelectorAll('input[type="file"]')
                        .forEach(function (input) {
                            input.value = '';
                        });

                    // Очистка кастомного списка файлов
                    formItem
                        .querySelectorAll('.list')
                        .forEach(function (list) {
                            list.innerHTML = '';
                        });

                    // Закрываем popup заявки
                    const bidDialog =
                        formItem.closest('#popup-bid');

                    if (
                        bidDialog &&
                        typeof bidDialog.close === 'function'
                    ) {
                        bidDialog.close();
                    }

                    // Показываем окно благодарности
                    const thankDialog =
                        document.querySelector('#popup-thank');

                    if (thankDialog) {
                        if (
                            typeof window.disableScroll ===
                            'function'
                        ) {
                            window.disableScroll();
                        }

                        if (
                            typeof thankDialog.showModal ===
                            'function'
                        ) {
                            thankDialog.showModal();
                        }
                    }

                    // Цель для статичной формы
                    if (isStaticForm) {
                        sendMetricaGoal('staticAction');
                    }

                    // Цель для формы в popup
                    if (isPopupForm) {
                        sendMetricaGoal('popupAction');
                    }

                    // Цель для всех форм обратной связи
                    sendMetricaGoal('allFormsAction');
                })
                .catch(function (error) {
                    console.error(
                        'Ошибка отправки формы:',
                        error
                    );

                    alert(
                        error.message || 'Ошибка соединения'
                    );
                })
                .finally(function () {
                    setFormSubmitting(formItem, false);
                });
        });
    });
}


// Отправка данных из корзины

function initCheckoutOrderForm() {
    const form = document.querySelector(
        '#form-checkout form'
    );

    if (!form) {
        return;
    }

    function collectCartFromDOM() {
        const items = [];

        document
            .querySelectorAll('.cart-table .tbody .item')
            .forEach(function (row) {
                const name = (
                    row.querySelector('.col a p')
                        ?.textContent || ''
                ).trim();

                const quantity = (
                    row.querySelector('input[type="number"]')
                        ?.value || ''
                ).trim();

                const link =
                    row.querySelector('.col a')?.href || '';

                const unitRaw = (
                    row.querySelector(
                        '.cart-qty .clr-400'
                    )?.textContent || ''
                )
                    .replace(/\s+/g, ' ')
                    .trim();

                const totalRaw = (
                    row.querySelector('[data-total-id]')
                        ?.textContent || ''
                )
                    .replace(/\s+/g, ' ')
                    .trim();

                items.push({
                    name: name,
                    link: link,
                    quantity: quantity,
                    unit_price: unitRaw,
                    line_total: totalRaw
                });
            });

        // Итоговая стоимость
        let grandTotal = '';

        const grandTotalValue = document.querySelector(
            '#cart-grand-total-value'
        );

        const grandTotalBlock = document.querySelector(
            '#cart-grand-total'
        );

        if (grandTotalValue) {
            grandTotal = grandTotalValue.textContent
                .replace(/\s+/g, ' ')
                .trim();
        } else if (grandTotalBlock) {
            grandTotal = grandTotalBlock.textContent
                .replace(/\s+/g, ' ')
                .trim();
        }

        return {
            items: items,
            grandTotal: grandTotal
        };
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Проверка стандартных required-полей
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        // Проверка SmartCaptcha
        if (!validateSmartCaptcha(form)) {
            return;
        }

        setFormSubmitting(form, true);

        const formData = new FormData(form);
        const cart = collectCartFromDOM();

        formData.append('source', 'checkout');

        formData.append(
            'grand_total',
            cart.grandTotal || ''
        );

        formData.append(
            'products',
            JSON.stringify(cart.items || [])
        );

        console.log('Products to send:', cart.items);

        fetch(
            'index.php?route=checkout/checkout/sendOrderRequest',
            {
                method: 'POST',
                body: formData
            }
        )
            .then(function (response) {
                return response.text().then(function (text) {
                    return {
                        ok: response.ok,
                        text: text
                    };
                });
            })
            .then(function (responseData) {
                let data;

                console.log(
                    'Raw checkout response:',
                    responseData.text
                );

                try {
                    data = JSON.parse(responseData.text);
                } catch (error) {
                    console.error(
                        'Ответ сервера не является JSON:',
                        responseData.text
                    );

                    throw new Error(
                        'Некорректный ответ сервера'
                    );
                }

                if (!responseData.ok) {
                    throw new Error(
                        data.message || 'Ошибка сервера'
                    );
                }

                if (data.status !== 'success') {
                    alert(
                        data.message || 'Ошибка отправки'
                    );

                    return;
                }

                // Сброс формы
                form.reset();

                // Очистка file inputs
                form
                    .querySelectorAll('input[type="file"]')
                    .forEach(function (input) {
                        input.value = '';
                    });

                // Очистка кастомных списков файлов
                form
                    .querySelectorAll('.list')
                    .forEach(function (list) {
                        list.innerHTML = '';
                    });

                // Показываем окно благодарности
                const thankDialog =
                    document.querySelector('#popup-thank');

                if (thankDialog) {
                    if (
                        typeof window.disableScroll ===
                        'function'
                    ) {
                        window.disableScroll();
                    }

                    if (
                        typeof thankDialog.showModal ===
                        'function'
                    ) {
                        thankDialog.showModal();
                    }
                }

                // Цель отправки заказа
                sendMetricaGoal('cartAction');
            })
            .catch(function (error) {
                console.error(
                    'Ошибка отправки заказа:',
                    error
                );

                alert(
                    error.message || 'Ошибка соединения'
                );
            })
            .finally(function () {
                setFormSubmitting(form, false);
            });
    });
}

function popupSearch() {
    const searchInput = document.querySelector('#popup-cities .search-input input');
    const cityLinks = document.querySelectorAll('#popup-cities .cities-list a');

    if (!searchInput) return;

    searchInput.addEventListener('input', () => {
        const val = searchInput.value.trim().toLowerCase();

        cityLinks.forEach(link => {
            const text = link.textContent.trim().toLowerCase();

            if (val === '' || text.startsWith(val)) {
                link.style.display = '';
            } else {
                link.style.display = 'none';
            }
        });
    });
}

function scaleBigScreens() {
    if (!window.matchMedia('(min-width: 1921px)').matches) return;

    const baseWidth = 1920;
    const maxScale = 1.1;
    const vw = window.innerWidth;
    const scale = Math.min(vw / baseWidth, maxScale);
    const socialScale = Math.min(vw / baseWidth, 1.2);

    document.querySelectorAll('[class*="s"], .group-title, .group-link').forEach(el => {
        const match = el.className.match(/s(\d+)x(\d+)/);

        if (match) {
            const fontSize = parseInt(match[1], 10);
            const lineHeight = parseInt(match[2], 10);
            el.style.fontSize = `${fontSize * scale}px`;
            el.style.lineHeight = `${lineHeight * scale}px`;
        } else {
            const computed = window.getComputedStyle(el);
            const fontSize = parseFloat(computed.fontSize);
            const lineHeight = parseFloat(computed.lineHeight);
            el.style.fontSize = `${fontSize * scale}px`;
            el.style.lineHeight = `${lineHeight * scale}px`;
        }
    });

    document.querySelectorAll('.btn, .ui-social-item').forEach(el => {

        if (el.closest('.cart-table')) return;
        if (el.closest('.product-price')) return;

        const computed = window.getComputedStyle(el);
        const paddingTop = parseFloat(computed.paddingTop);
        const paddingBottom = parseFloat(computed.paddingBottom);
        const paddingLeft = parseFloat(computed.paddingLeft);
        const paddingRight = parseFloat(computed.paddingRight);
        const height = parseFloat(computed.height);
        const minWidth = parseFloat(computed.width);
        const fontSize = parseFloat(computed.fontSize);
        const lineHeight = parseFloat(computed.lineHeight);

        const currentScale = el.classList.contains('ui-social-item') ? socialScale : scale;

        el.style.paddingTop = `${paddingTop * currentScale}px`;
        el.style.paddingBottom = `${paddingBottom * currentScale}px`;
        el.style.paddingLeft = `${paddingLeft * currentScale}px`;
        el.style.paddingRight = `${paddingRight * currentScale}px`;
        el.style.height = `${height * currentScale}px`;

        if (!(el.closest('.card-product') && el.classList.contains('btn-primary'))) {
            el.style.minWidth = `${minWidth * currentScale}px`;
        }

        el.style.fontSize = `${fontSize * currentScale}px`;
        el.style.lineHeight = `${lineHeight * currentScale}px`;
    });
}

function scaleSmallScreens() {

    if (!window.matchMedia('(min-width: 1281px) and (max-width: 1681px)').matches) return;

    const scale = 0.9;
    const socialScale = 0.9;

    document.querySelectorAll('[class*="s"], .group-title, .group-link').forEach(el => {
        const match = el.className.match(/s(\d+)x(\d+)/);

        if (match) {
            const fontSize = parseInt(match[1], 10);
            const lineHeight = parseInt(match[2], 10);
            el.style.fontSize = `${fontSize * scale}px`;
            el.style.lineHeight = `${lineHeight * scale}px`;
        } else {
            const computed = window.getComputedStyle(el);
            const fontSize = parseFloat(computed.fontSize);
            const lineHeight = parseFloat(computed.lineHeight);
            el.style.fontSize = `${fontSize * scale}px`;
            el.style.lineHeight = `${lineHeight * scale}px`;
        }
    });


    document.querySelectorAll('.btn, .ui-social-item').forEach(el => {

        if (el.closest('.cart-table')) return;       
        if (el.closest('.product-price')) return;

        const computed = window.getComputedStyle(el);
        const paddingTop = parseFloat(computed.paddingTop);
        const paddingBottom = parseFloat(computed.paddingBottom);
        const paddingLeft = parseFloat(computed.paddingLeft);
        const paddingRight = parseFloat(computed.paddingRight);
        const height = parseFloat(computed.height);
        const minWidth = parseFloat(computed.width);
        const fontSize = parseFloat(computed.fontSize);
        const lineHeight = parseFloat(computed.lineHeight);

        const currentScale = el.classList.contains('ui-social-item') ? socialScale : scale;

        el.style.paddingTop = `${paddingTop * currentScale}px`;
        el.style.paddingBottom = `${paddingBottom * currentScale}px`;
        el.style.paddingLeft = `${paddingLeft * currentScale}px`;
        el.style.paddingRight = `${paddingRight * currentScale}px`;
        el.style.height = `${height * currentScale}px`;

        if (!(el.closest('.card-product') && el.classList.contains('btn-primary'))) {
            el.style.minWidth = `${minWidth * currentScale}px`;
        }

        el.style.fontSize = `${fontSize * currentScale}px`;
        el.style.lineHeight = `${lineHeight * currentScale}px`;
    });
}

function yandexGoals() {

    /* Клик на кнопку - рассчитать стоимость */
    document.querySelectorAll('[data-popup="popup-bid"]').forEach(function(btn) {
        btn.addEventListener('click', function() {
            ym(42169839, 'reachGoal', 'popupBtn');
        });
    });

    /* Взаимодействие с формой - рассчитать стоимость */
    document.querySelectorAll('#popup-bid input').forEach(function(input) {
        input.addEventListener('click', function() {
            ym(42169839, 'reachGoal', 'popupInput');
        });
    });

    /* Взаимодействие с формой - оставьте заявку */
    document.querySelectorAll('.form-callback input').forEach(function(input) {
        input.addEventListener('click', function() {
            ym(42169839, 'reachGoal', 'staticInput');
        });
    });

    /* Переход на страницу товара */
    if (document.querySelector('.product-page')) {
        ym(42169839, 'reachGoal', 'productCard');
    }

    /* Скопировать почтовый адрес */
    document.querySelectorAll('a[href^="mailto:"]').forEach(function(email) {
        email.addEventListener('copy', function() {
            ym(42169839, 'reachGoal', 'emailCopy');
        });
    });

}

async function cityChecker() {
  const blocks = document.querySelectorAll('.city-checker');
  if (!blocks.length) return;

  const SIXTY_DAYS = 60 * 24 * 60 * 60;
  const COOKIE_NAME = 'aldeksCityCheck';

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=.aldeks.ru";
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  const checkedUntil = getCookie(COOKIE_NAME);
  const isChecked = checkedUntil && (Date.now() / 1000 < parseInt(checkedUntil, 10));

  let geoData = null;
  if (!isChecked) {
    try {

      const params = new URLSearchParams(window.location.search);
      const debugIp = params.get('debug_ip');
      const debugJson = params.get('debug_json');
      let url = '/index.php?route=common/city_check';
      if (debugIp) url += `&debug_ip=${debugIp}`;
      if (debugJson) url += `&debug_json=${debugJson}`;

      const res = await fetch(url);
      geoData = await res.json();
      console.log('GeoData:', geoData);
    } catch (e) {
      console.error('City fetch error', e);
    }
  }

  blocks.forEach(block => {
    const closeLinks = block.querySelectorAll('.close-city');
    const changeBtn  = block.querySelector('.change-city');

    if (!isChecked && geoData && geoData.city) {

        const citySpan = block.querySelector('.fw-500');
        if (citySpan) citySpan.textContent = geoData.city;

        let cleanUrl = geoData.url;
        try {
            const u = new URL(geoData.url);
            cleanUrl = u.origin + window.location.pathname; 
        } catch (e) {
            console.error('Bad URL in geoData', geoData.url);
        }

        closeLinks.forEach(link => {
            link.href = cleanUrl;
        });

        block.classList.add('is-active');
    }

    function hideBlock() {
      block.style.transition = 'transform 0.6s ease, opacity 0.6s ease';
      block.style.transform = 'translateY(-20rem)';
      block.style.opacity = '0';
      setTimeout(() => {
        block.classList.remove('is-active');
        block.removeAttribute('style');
      }, 600);
    }

    closeLinks.forEach(link => {
      link.addEventListener('click', () => {
        const until = Math.floor(Date.now() / 1000) + SIXTY_DAYS;
        setCookie(COOKIE_NAME, until, 60);
        hideBlock();
      });
    });

    if (changeBtn) {
      changeBtn.addEventListener('click', () => {
        const until = Math.floor(Date.now() / 1000) + SIXTY_DAYS;
        setCookie(COOKIE_NAME, until, 60);
        hideBlock();
      });
    }
  });

  const popupLinks = document.querySelectorAll('.popup-thank .cities-list a');
  popupLinks.forEach(link => {
    link.addEventListener('click', () => {
      const until = Math.floor(Date.now() / 1000) + SIXTY_DAYS;
      setCookie(COOKIE_NAME, until, 60);
    });
  });
}

function init() {
    initPopup('bid');
    initPopup('thank');
    initPopup('search');
    initPopup('callback');
    initPopup('catalog');
    initPopup('menu');
    initPopup('gallery');
    initPopup('cities');
    
    initHeaderSubMenu();
    headerMode('light');
    window.addEventListener('scroll', headerScroll);

    initTabs();
    initInputFiles();
    initMaskPhone();

    initSlyders();
    indexItemsNumbers();
    updateGoodsCount();
    initLoadMore();
    initSubCategoryButtons();

    liveSearch();

    updateCartCountOnLoad();
    cart();
    initCartClear();
    initCartQtyButtons();
    initCartRemoveButtons();
    recalcCartTotal();

    initTagFilter();
    initFooterColToggle();
    initPopupCatalogToggle();
    
    informationLinkContents();

    initCallbackForm();
    initCheckoutOrderForm();
    popupSearch();
    scaleBigScreens();
    scaleSmallScreens();
    cityChecker();
    yandexGoals();
    initMap();
 
}

document.addEventListener("DOMContentLoaded", (event) => {

    init();

});